<template><div>
	<nav>
		<v-app-bar app dark xhide-on-scroll color="#1e69ac">
			<v-app-bar-nav-icon @click="drawer = !drawer" />
			<v-toolbar-title>
				<span> Nao </span>
			</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-btn class="hidden-xs-only" v-for="b in nav_buttons" text v-text="$t(b.title)" router :to="b.route"> </v-btn>

			<v-menu offset-y bottom open-on-hover
			    transition="slide-y-transition"
			    :close-on-click="true"
		    >
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						class="hidden-xs-only"
					    text
					    v-bind="attrs"
					    v-on="on"
					> {{ "Learning" | t }} </v-btn>
				</template>

				<v-list>
					<v-list-item v-for="(item, index) in learning" :key="index" router :to="item.route">
						<v-list-item-title>{{ item.title | t }}</v-list-item-title>
					</v-list-item>
				</v-list>
		    </v-menu>

			<v-menu offset-y bottom open-on-hover
			    transition="slide-y-transition"
			    :close-on-click="true"
		    >
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						class="hidden-xs-only"
					    text
					    v-bind="attrs"
					    v-on="on"
					> {{ "Other" | t }} </v-btn>
				</template>

				<v-list>
					<v-list-item v-for="(item, index) in other" :key="index" router :to="item.route">
						<v-list-item-title>{{ item.title | t }}</v-list-item-title>
					</v-list-item>
				</v-list>
		    </v-menu>

		    <v-btn v-if="phone" icon @click="chat_open = !chat_open"><v-icon> {{ $mdi.Chat }}  </v-icon></v-btn>

		    <v-menu offset-y bottom open-on-hover
			    transition="slide-y-transition"
			    :close-on-click="true"
		    >
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on"
					><v-icon> {{ $mdi.Translate }} </v-icon></v-btn>
				</template>

				<v-list>
					<v-list-item v-for="(lan, index) in languages" :key="index" @click="change_language(lan.code)">
						<v-list-item-title>{{ lan.name }}</v-list-item-title>
					</v-list-item>
				</v-list>
		    </v-menu>

		</v-app-bar>

		<v-navigation-drawer temporary v-model="drawer" app >
			<v-list-item>
		        <v-list-item-content>
		          <v-list-item-title class="title">
		            Nao
		          </v-list-item-title>
		        </v-list-item-content>
		      </v-list-item>

		      <v-divider></v-divider>

		      <v-list dense nav>
		        <v-list-item
		          v-for="item in nav_buttons.concat(learning).concat(other)"
		          :key="item.title"
		          router :to="item.route"
		        >
		          <v-list-item-content>
		            <v-list-item-title>{{ item.title | t }}</v-list-item-title>
		          </v-list-item-content>
		        </v-list-item>
		    </v-list>
		</v-navigation-drawer>
	</nav>

	<Popover v-show="tr" name="naoword">
	  	<v-card class="pa-3" elevation="10" v-if="tr && tr.filter(x => x.main_tr).length > 0">
	  		<div v-for="t in tr">
		  		<span v-if="tr.length > 1" :class="$css.naoword"> {{ t.nao }} = </span> {{ t.main_tr }}
		  	</div>
	  	</v-card>
	</Popover>


	<v-dialog v-model="disassemble_dialog" width="500" :retain-focus="false">

	<v-card class="mx-auto" max-width="500">
	    <v-card-title class="grey lighten-2" style="word-break: normal">
	      {{ dis.main_tr }}
	    </v-card-title>

	    <v-card-text>
	      <v-treeview :items="dis.children" transition>
	        <template v-slot:prepend="{ item }">

				<v-layout class="ma-1 awesome_border">
					<div>
						<div class="main_color font-weight-medium">
							{{ item.nao }}
							<v-tooltip right>
						      <template v-slot:activator="{ on, attrs }">
						      	<v-btn @click="$nao.pronounce($nao.disassemble(item.nao))" v-bind="attrs" v-on="on" icon><v-icon> {{ $mdi.VolumeHigh }} </v-icon></v-btn>
						      </template>
						      <span>Pronounce</span>
						    </v-tooltip>
						</div>

						<div> <span> {{ item.main_tr }} </span> </div>
					</div>
				</v-layout>

	        </template>
	      </v-treeview>
	    </v-card-text>

	    <v-divider></v-divider>

	    <v-card-actions>
	      <v-spacer></v-spacer>
	      <v-btn text color="primary" @click="disassemble_dialog = false"> OK </v-btn>
	    </v-card-actions>
	</v-card>

	</v-dialog>

	<v-btn v-if="!phone && !chat_open" class="in_corner" fab dark @click="chat_open = true"> <v-icon large> {{ $mdi.Chat }} </v-icon> </v-btn>

	<div v-if="!phone">
		<transition
			name="custom-classes-transition"
			enter-active-class="animated bounceInUp"
			leave-active-class="animated zoomOut"
		>
			<v-card v-show="chat_open" rounded elevation="20" class="in_corner">
				<Chat @close_chat="chat_open = false" style="height: 500px; width: 300px"/>
			</v-card>

		</transition>
	</div>

	<div v-else>
		<v-dialog
		      :value="chat_open"
		      fullscreen
		      hide-overlay
		      transition="scale-transition"
		>
			<Chat style="height: 100%" @close_chat="chat_open = false"/>
		</v-dialog>
	</div>




</div></template>

<script>
// <div :class="$css.naoword"> {{ t.nao }} </div>



import Vue from 'vue'
import Popover from '@/components/Popover'
import Chat from '@/components/Chat'


Vue.directive('popover', {
	inserted(el, binding) {
		let P = Popover.methods.get_popover(binding.arg);
		if (!P) return;

		if (P.click) {
			el.addEventListener('click', function(event){
				if (binding.value) {
					if (binding.value.on_open) binding.value.on_open();
				}
				P.active = true;
				P.stick_to(el);
			});
			el.addEventListener('blur', function(event){
				P.active = false;
			});
		}
		else {
			el.addEventListener('mouseover', function(event){
				if (binding.value) {
					if (binding.value.on_open) binding.value.on_open();
				}
				P.active = true;
				P.stick_to(el);
			});
			el.addEventListener('mouseleave', function(event){
				P.active = false;
			});
		}
	}
})

export default {
	components: {Popover, Chat},
	data() {
		return {
			tr: null,
			disassemble_dialog: false,
			chat_open: false,
			dis: [],
			drawer: false,
			nav_buttons: [
				{title: 'FAQ', route: '/faq'},
				{title: 'Dictionary', route: '/dict'},
				{title: 'Community', route: '/community'},
			],
			learning: [
		        { title: 'Textbook', route: '/textbook'},
		        { title: 'Full Set of Rules', route: '/full-set-of-rules'},
		        { title: 'Reading', route: '/reading'},
		        { title: 'Elements', route: '/elements'},
		        { title: 'Combinations', route: '/combinations'},
		        { title: 'Game', route: '/game'},
		        { title: 'Crossword', route: '/crossword'},
		        { title: 'Transliterations', route: '/transliterations'},
		    ],
		    other: [
		    	{ title: 'Updates', route: '/updates'},
		    	{ title: 'Other conlangs', route: '/comparison'},
		    	{ title: 'Origins', route: '/origins'},
		    ],
		    languages: [ {name:'English', code:'en'} , {name:'Русский', code:'ru'}, {name:'日本語', code:'ja'} ],
		}
	},
	created() {
		let A = this;
		Vue.prototype.$popover_naoword = function(tr) {
			A.tr = tr;
		}
		Vue.prototype.$show_disassemble = function(w) {
			A.dis = A.$nao.disassemble_deep(w)[0];
			A.disassemble_dialog = true;
		}
	},
	methods: {
		change_language(code) {
			this.$store.commit('change_language', code);
		}
	},
	computed: {
		phone() {
			return this.$vuetify.breakpoint.xs;
		}
	}
}

</script>

<style scoped>

.awesome_border {
	border-left-style: solid;
	border-left-color: #2196F35A;
	xborder-left-color: #00000030;
	border-width: 4px;
	padding-left: 10px;
	xbackground-color: #2196F32A;
}

.in_corner {
	z-index: 5;
	position: fixed;
	right: 30px;
	bottom: 10px;
}

</style>